import { render } from "./drawer.vue?vue&type=template&id=71724b1a&scoped=true"
import script from "./drawer.vue?vue&type=script&lang=js"
export * from "./drawer.vue?vue&type=script&lang=js"

import "./drawer.vue?vue&type=style&index=0&id=71724b1a&scoped=true&lang=css"
import "./drawer.vue?vue&type=style&index=1&id=71724b1a&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71724b1a"]])

export default __exports__